module.exports = __webpack_public_path__ + "static/media/newBusiness.62b5eb03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/newBusiness.jpg
// module id = 609
// module chunks = 0